export const ADVANCE = {
  ADVANCES: 'advances',
  ADVANCES_PAID_SUM: 'ADVANCES_PAID_SUM',
  ADVANCES_INSTALLMENTS_TO_REPAY: 'ADVANCES_INSTALLMENTS_TO_REPAY',
  ADVANCE_INSTALLMENT: 'advance_installment',
  ADVANCES_PAID_SUM: 'advances_paid_sum',
  ADVANCES_INSTALLMENTS_TO_REPAY: 'advances_installments_to_repay',
};
